// GeneralInfo.js
import React, { useState , useContext} from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import 'react-phone-number-input/style.css'
import InputMask from 'react-input-mask';
import { UserContext } from "../../../../context/FormDataContext";
import './Opencall.css'

const Opencall = () => {
  const { userData } = useContext(UserContext);
  const { values, setFieldValue, errors } = useFormikContext();
  const [isFocused, setIsFocused] = useState(false);
  

  console.log("errorserrorserrors", errors)

  
   
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
  };
  
console.log(userData.phone, 'this is phone number')
  return (
    <div className="">
      <div className="row">
        <div className="col-12 col-xs-12 col-md-12 px-0">
          <div className="host_form academyForm py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">
                    Full name<span class="required">*</span>
                  </label>
                  <Field
                  required
                    type="text"
                    value={values.first_name || userData.firstName}
                    onChange={handleInputChange}
                    className="form-control"
                    
                    id="first_name"
                    name="first_name"
                    // placeholder="John"
                    placeholder="Enter first name"
                    
                  />
                  <ErrorMessage
                    name="first_name"
                    component="div"
                    className="invalid-feedback"
                    
                  />
                </div>
              </div>
      

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="phone_number" className="form-label">
                    Phone Number<span class="required">*</span>
                  </label>
                  <div className="row border align-items-center countryflag">
                    <div className="col-2 p-0 d-flex align-items-center text-center countrycode">
                      <img
                        src="/img/us.svg"
                        className="img-fluid me-2"
                        alt="Country Flag"
                      />
                      <span>+1</span>
                    </div>
                    <div className="col-10 p-0">
                      <InputMask
                        mask="(999) 999-9999"
                        // value={values.phone_number || ''}
                        value={values.phone_number || userData.phone}
                        onChange={(e) => setFieldValue('phone_number', e.target.value)}
                        className="form-control"
                     
                        id="phone_number"
                        placeholder="Enter phone number"
                        maskChar={null}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        formatCharacters={{ '9': '[0-9]' }}
                          >
                        {(inputProps) => <Field {...inputProps} name="phone_number" />}
                      </InputMask>
                    </div>
                  </div>
                  <ErrorMessage
                    name="phone_number"
                    component="div"
                    className="invalid-feedback"
                  />
                  {/* <ErrorMessage
                          name="phone_number"
                          component="div"
                          className="invalid-feedback"
                        />  */}
                  {/* <PhoneInput
                    id="phone_number"
                    limitMaxLength="10"
                    defaultCountry="US"
                    placeholder="(999) 999-9999"
                    value={values.phone_number}
                    onChange={handlePhoneChange}
                  />
                  {
                    errors?.phone_number && (
                      <ErrorMessage
                      name="phone_number"
                      component="div"
                      className="invalid-feedback"
                    />
                    )
                  }                 */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email address<span class="required">*</span>
                  </label>
                  <Field
                value={values.email_address || userData.email}
                onChange={handleInputChange}
                required
                    type="email"
                    className="form-control"
                  
                    id="email_address"
                    name="email_address"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email_address"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>


              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="companyName" className="form-label">
                  Company/Organization Name<span class="required">*</span>
                  </label>
                  <Field
                    required
                  value={values.companyName || userData.companyName}
                  onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    id="companyName"
                    name="companyName"
                    placeholder="Enter your company or organization name"
                  />
                  <ErrorMessage
                    name="companyName"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="companyName" className="form-label">
                  Role/Title
                  </label>
                  <Field
                    required
                  value={values.companyName || userData.companyName}
                  onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    id="companyName"
                    name="companyName"
                    placeholder="Enter your professional role or title"
                  />
                  <ErrorMessage
                    name="companyName"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="companyName" className="form-label">Social Media Channel</label>
                    <div className="socialMediaForm">
                        <div className="socialMediaFormLeft">
                        <small>1</small>
                          <Field
                            required
                            value={values.companyName || userData.companyName}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            id="companyName"
                            name="companyName"
                            placeholder="Social media link"
                          />
                       </div>


                      <div className="socialMediaFormRight">
                          <label htmlFor="" className="form-label labelFollwer">Follower Counts</label>
                          <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/minus.svg" alt="icon"/>
                            </button>
                            <button type="button" class="btn">(e.g. 2000)</button>
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon"/>
                            </button>
                        </div>
                      </div>
                    </div>
                    <div className="socialMediaForm">
                        <div className="socialMediaFormLeft">
                        <small>2</small>
                          <Field
                            required
                            value={values.companyName || userData.companyName}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            id="companyName"
                            name="companyName"
                            placeholder="Social media link"
                          />
                       </div>


                      <div className="socialMediaFormRight">
                          <label htmlFor="" className="form-label labelFollwer">Follower Counts</label>
                          <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/minus.svg" alt="icon"/>
                            </button>
                            <button type="button" class="btn">(e.g. 2000)</button>
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon"/>
                            </button>
                        </div>
                      </div>
                    </div>
                    <div className="socialMediaForm">
                        <div className="socialMediaFormLeft">
                        <small>3</small>
                          <Field
                            required
                            value={values.companyName || userData.companyName}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            id="companyName"
                            name="companyName"
                            placeholder="Social media link"
                          />
                       </div>


                      <div className="socialMediaFormRight">
                          <label htmlFor="" className="form-label labelFollwer">Follower Counts</label>
                          <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/minus.svg" alt="icon"/>
                            </button>
                            <button type="button" class="btn">(e.g. 2000)</button>
                            <button type="button" class="btn">
                                <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon"/>
                            </button>
                        </div>
                      </div>
                    </div>

                  <ErrorMessage
                    name="companyName"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div class="footer-btn-sec">
                  <a type="button" class="btn btnTransparent_21">
                    <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon"/> Add New Row
                  </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opencall;
